import { c as _c } from "react/compiler-runtime";
import { LocalAlert } from "@navikt/ds-react";
import type { ErrorDetail } from "@/server/narmesteLederErrorUtils";
import { UiSelector } from "@/utils/uiSelectors";
type ErrorAlertProps = {
  detail?: ErrorDetail;
};
const DEFAULT_TITLE = "Beklager! Det har oppstått en uventet feil";
const DEFAULT_MESSAGE = "Vi klarte ikke å sende inn svarene dine. Prøv igjen om litt.";
export default function ErrorAlert(t0) {
  const $ = _c(7);
  const {
    detail
  } = t0;
  const title = detail?.title ?? DEFAULT_TITLE;
  const content = detail?.message ?? DEFAULT_MESSAGE;
  let t1;
  if ($[0] !== title) {
    t1 = <LocalAlert.Header><LocalAlert.Title>{title}</LocalAlert.Title></LocalAlert.Header>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== content) {
    t2 = <LocalAlert.Content>{content}</LocalAlert.Content>;
    $[2] = content;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <LocalAlert status="error" data-testid={UiSelector.ErrorAlert}>{t1}{t2}</LocalAlert>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}